import { z } from "zod";

export const emailCollectionSchema = z.object({
  email: z
    .string()
    .trim()
    .email({ message: "Invalid email address." })
    .optional()
    .or(z.literal("")),
});

export type EmailCollectionSchemaType = z.infer<typeof emailCollectionSchema>;
